/*--------------------------------------------
- EXTERNAL LINKS
---------------------------------------------*/

/* Algemeen
---------------------------------------------*/
export const LINK_CONTACT_US = 'https://www.vrt.be/heb-je-een-vraag/s/contactus';
export const LINK_PRIVACY = 'https://www.vrt.be/nl/info/privacy';
export const LINK_TERMS_OF_USE = 'https://www.vrt.be/nl/info/gebruiksvoorwaarden';
export const LINK_MANAGEMENT_CONTRACT = 'https://www.vrt.be/nl/over-ons/onze-opdracht/beheersovereenkomst';

/* FAQ
---------------------------------------------*/
export const LINK_FAQ = 'https://www.vrt.be/nl/info/vrt-profiel';
export const LINK_FAQ_ABOUT = 'https://www.vrt.be/nl/info/vrt-profiel/vragen-over-vrt-profiel';
export const LINK_FAQ_ERRORS = 'https://www.vrt.be/nl/info/vrt-profiel/hulp-bij-foutmeldingen';
